var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_534_151",
    transform: "scale(0.0166667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_534_151",
    width: 60,
    height: 60,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAByUlEQVRoge2ZS07DMBCGbcQpeNyHsqAIUXUBSyQu1nM1UmmLeNygiI8FiUhdJ7UHu0mj+VatZHvmz0zyx7ExiqIoiqL0FuAaKEhPAYwi8hgD78AbcJNT8DKD2IqXiDxWtXlLqZ6TgDHf0sUDsBFjz2q/z6UBQwQ/G2MKaYAWCmPMU4Z1W4m5wp0CUP9vrRXlHlLhQaGCh85ewaTz4SjfzcXeGx9YGGMuE8VbWWsvJBP1oSXkkD7cie+6qA8PHRU8dHL6cC981yW3D4t915OHPrQk5PThXviui/rw0FHBQyeHD/fSf4MBFoKXDvF345Y8tpCuoy3tIdaHe+m/FerDQ0cFD50UPpzEd4EJ8MnvseitYP64zGUBjP+TSMj5cPA5b0MMC3zU1tsAU2dMow8D03JOxbopVkhLi00+FGstZvsc+tQYM3NF+yjHzMo5FRtxMsAImLdUdw5ciQP8xblzqrRVaV+FPZWt5shb+pAA9x4BX8Cj50JPGsY+dK0jipaquTR2w9HRUOk2jq+yLhGi04pl14cPtt/F39552xj/fjj5frclflOl87Rx14LLHFzR+e5Zdn04ie8K8hgDa+AVwaunoiiKoijd8wOIE9wP57iIhAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.17ec1000c2cb8a25db65d3acbb4a0493.svg";
export { ForwardRef as ReactComponent };